export const DELETE_SPOT_REQUEST = 'DELETE_SPOT_REQUEST';

export const deleteSpotRequest = ( id: string ) => ({
    type: DELETE_SPOT_REQUEST,
    payload: { id }
});
